(() => {
  if (!customElements.get('paddle-shop-hub')) {
    class PaddleShopHub extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('[data-hub-row]'));
        this.defaultRow = this.dataset.defaultRow || 'level';

        this.rows.forEach((row) => {
          const trigger = row.querySelector('[data-hub-trigger]');
          trigger?.addEventListener('click', () => {
            const isOpen = row.classList.contains('is-open');
            this.rows.forEach((candidate) => this.setRow(candidate, false));
            if (!isOpen) this.setRow(row, true);
          });
        });

        this.rows.forEach((row) => {
          this.setRow(row, row.dataset.hubRow === this.defaultRow);
        });
        this.classList.add('is-ready');
      }

      setRow(row, isOpen) {
        const trigger = row.querySelector('[data-hub-trigger]');
        const panel = row.querySelector('[data-hub-panel]');
        const state = row.querySelector('[data-hub-state]');
        const openLabel = this.dataset.openLabel || 'VIEW';
        const closeLabel = this.dataset.closeLabel || 'CLOSE';

        row.classList.toggle('is-open', isOpen);
        trigger?.setAttribute('aria-expanded', String(isOpen));
        if (panel) panel.inert = !isOpen;
        if (state) state.textContent = isOpen ? closeLabel : openLabel;
      }
    }

    customElements.define('paddle-shop-hub', PaddleShopHub);
  }

  if (!customElements.get('paddle-live-grid')) {
    class PaddleLiveGrid extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-paddle-tab]'));
        this.chips = Array.from(this.querySelectorAll('[data-paddle-chip]'));
        this.cards = Array.from(this.querySelectorAll('[data-paddle-product]'));
        this.count = this.querySelector('[data-paddle-count]');
        this.blurb = this.querySelector('[data-paddle-blurb]');
        this.empty = this.querySelector('[data-paddle-empty]');
        this.reset = this.querySelector('[data-paddle-reset]');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const taxonomy = tab.dataset.taxonomy;
            const firstChip = this.chips.find((chip) => chip.dataset.taxonomy === taxonomy);
            this.apply(taxonomy, firstChip?.dataset.value || '', true);
          });
        });

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => {
            this.apply(chip.dataset.taxonomy, chip.dataset.value, true);
          });
        });

        this.reset?.addEventListener('click', () => {
          const firstTab = this.tabs[0];
          const taxonomy = firstTab?.dataset.taxonomy || 'level';
          const firstChip = this.chips.find((chip) => chip.dataset.taxonomy === taxonomy);
          this.apply(taxonomy, firstChip?.dataset.value || '', true);
        });

        window.addEventListener('popstate', () => this.applyFromUrl());
        this.applyFromUrl();
        this.classList.add('is-ready');
      }

      applyFromUrl() {
        const url = new URL(window.location.href);
        let taxonomy = url.searchParams.get('by') || this.tabs[0]?.dataset.taxonomy || 'level';
        if (!this.tabs.some((tab) => tab.dataset.taxonomy === taxonomy)) {
          taxonomy = this.tabs[0]?.dataset.taxonomy || 'level';
        }

        const available = this.chips.filter((chip) => chip.dataset.taxonomy === taxonomy);
        let value = url.searchParams.get('value') || available[0]?.dataset.value || '';
        if (!available.some((chip) => chip.dataset.value === value)) {
          value = available[0]?.dataset.value || '';
        }

        this.apply(taxonomy, value, false);
      }

      apply(taxonomy, value, updateUrl) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.taxonomy === taxonomy;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        let activeChip;
        this.chips.forEach((chip) => {
          const relevant = chip.dataset.taxonomy === taxonomy;
          const active = relevant && chip.dataset.value === value;
          chip.hidden = !relevant;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', String(active));
          if (active) activeChip = chip;
        });

        let visibleCount = 0;
        this.cards.forEach((card) => {
          const values = String(card.dataset[taxonomy] || '').split(/\s+/).filter(Boolean);
          const visible = values.includes(value);
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (this.count) {
          this.count.textContent = `${visibleCount} ${visibleCount === 1 ? 'paddle' : 'paddles'}`;
        }
        if (this.blurb) {
          this.blurb.textContent = activeChip?.dataset.blurb || '';
        }
        if (this.empty) {
          this.empty.hidden = visibleCount !== 0;
        }

        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('by', taxonomy);
          url.searchParams.set('value', value);
          window.history.pushState({}, '', url);
        }
      }
    }

    customElements.define('paddle-live-grid', PaddleLiveGrid);
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-paddle-sort]');
    if (!select) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.assign(url);
  });
})();
